export const BLOCK_TEMPLATE = {
    LEGACY_BANNER: 'legacy-banners',
    ACTIVITY_RATING: 'activity-rating',
    TEXT_BLOCK: 'text-block',
    SHOP: 'shop',
    BUTTONS: 'buttons',
    POSTER: 'poster',
    COUNTDOWN: 'countdown',
    PARTNERS: 'partners',
    COVER: 'cover',
    QUIZZES: 'quizzes',
    CUSTOM_WIDGET: 'custom-widget',
    PLAYER: 'player',
    HALL_DESCRIPTION: 'hall-description',
    HALL_EPISODES: 'hall-episodes',
};

export const COMMON_BLOCKS_LIST = [
    {
        template: BLOCK_TEMPLATE.LEGACY_BANNER,
        allowMultiple: true,
    },
    {
        template: BLOCK_TEMPLATE.ACTIVITY_RATING,
    },
    {
        template: BLOCK_TEMPLATE.TEXT_BLOCK,
        allowMultiple: true,
    },
    {
        template: BLOCK_TEMPLATE.SHOP,
    },
    {
        template: BLOCK_TEMPLATE.BUTTONS,
        allowMultiple: true,
    },
];
